// extracted by mini-css-extract-plugin
module.exports = {"BooksTermsOfUse":"BooksTermsOfUse_BooksTermsOfUse__3mBkn","BooksTermsOfUse__Text":"BooksTermsOfUse_BooksTermsOfUse__Text__1HhiS"};